import { render, staticRenderFns } from "./HoldFileAttachments.vue?vue&type=template&id=41282302&scoped=true&"
import script from "./HoldFileAttachments.vue?vue&type=script&lang=ts&"
export * from "./HoldFileAttachments.vue?vue&type=script&lang=ts&"
import style0 from "./HoldFileAttachments.vue?vue&type=style&index=0&id=41282302&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41282302",
  null
  
)

export default component.exports